import React from "react";
import { useSelector } from "react-redux";
import Product from "./Product";

const AllProducts = () => {
  const products = useSelector((state) => state.product);
  return (
    <div className='col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-8 xxl:col-span-8'>
      {products.map((product) => (
        <Product ProductDetails={product} key={product.productId} />
      ))}
    </div>
  );
};

export default AllProducts;
